import React from "react"

interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  highlighted?: boolean
}

export function Card({ highlighted = false, className = "", ...rest }: CardProps) {
  return (
    <div
      className={`rounded-2xl border p-5 ${
        highlighted
          ? "border-gold-400 bg-gold-50/70 shadow-sm"
          : "border-slate-200 bg-white shadow-sm"
      } ${className}`}
      {...rest}
    />
  )
}
